import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-ss-alert-ia',
    templateUrl: './ss-alert-ia.component.html',
    styleUrls: ['./ss-alert-ia.component.scss'],
})
export class SsAlertIAComponent {
    constructor(public dialogo: MatDialogRef<SsAlertIAComponent>) {}

    close(): void {
        this.dialogo.close(false);
    }
    confirm(): void {
        this.dialogo.close(true);
    }
}
